// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes progress {
    0% {
      stroke-dashoffset: 251.2;
    }
    50% {
      stroke-dashoffset: 125.6;
    }
    100% {
      stroke-dashoffset: 251.2;
    }
  }

  .spinner {
    transform-origin: center;
    animation: rotate 1.5s linear infinite;
  }
`;

export default styles;
